import { render, staticRenderFns } from "./indicatorGroup.vue?vue&type=template&id=643d56e4&scoped=true&"
import script from "./indicatorGroup.vue?vue&type=script&lang=js&"
export * from "./indicatorGroup.vue?vue&type=script&lang=js&"
import style0 from "./indicatorGroup.vue?vue&type=style&index=0&id=643d56e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643d56e4",
  null
  
)

export default component.exports